<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="4000">
            {{ snackbar_msg }}
            <v-btn dark text @click="snackbar = false">
                Close
            </v-btn>
        </v-snackbar>

        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>
                    <strong>
                        Allocate Elective Choices
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn small color="info" class="mr-2" @click="import_dialog = true">
                    <v-icon small class="mr-1">
                        mdi-file-upload
                    </v-icon>
                    Import Data
                </v-btn>

            </v-toolbar>

            <v-row justify="center" class="mt-2 px-2">

                <v-col cols="12" sm="2" md="2">
                    <v-autocomplete dense outlined rounded return-object color="#0F2027" label="Academic Year"
                        v-model="sel_ay_data" :items="ay_std_div_list" item-text="ay" @change="getStd()" />
                </v-col>

                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-autocomplete dense outlined rounded color="#0F2027" label="Standard" v-model="sel_std_data"
                        :items="std_div_list" item-text="std" item-value="std_id" @change="getCourseOffering()" />
                </v-col>

                <v-col cols="12" sm="2" md="2" v-if="stream_list != null">
                    <v-autocomplete dense outlined rounded color="#0F2027" label="Stream" v-model="stream"
                        :items="stream_list" item-text="str" item-value="str_id" />
                </v-col>

                <v-col cols="12" sm="2" md="2" v-if="mixed_course_group_list != null">
                    <v-autocomplete dense outlined rounded color="#0F2027" label="Subject/Group" v-model="subject"
                        :items="mixed_course_group_list" item-text="name" item-value="id" return-object /></v-col>

                <v-col cols="auto" class="pt-5" v-if="stream && sel_std_data && sel_ay_data && subject">
                    <v-btn small color="primary" @click="fetchElectiveAllocation()" :loading="fetchLoader">
                        Fetch
                    </v-btn>
                </v-col>

                <v-col cols="auto" class="pt-5" v-if="stream && sel_std_data && sel_ay_data && subject">
                    <v-btn small dark color="primary" @click="openAddDialog()">
                        <v-icon small class="mr-1">
                            mdi-plus
                        </v-icon>
                        Allocate Elective
                    </v-btn>
                </v-col>
            </v-row>

            <v-row dense align="center" class="mt-2 ml-2" v-if="bookList1.length > 0">
                <v-col cols="12" class="d-flex align-center flex-wrap">
                    <v-btn color="primary" class="mr-2 mb-2" :disabled="selected.length == 0"
                        @click="sendNotification('EMAIL')" small>
                        <v-icon left>mdi-email</v-icon>
                        Send Email
                    </v-btn>
                    <v-btn color="success" class="mr-2 mb-2" :disabled="selected.length == 0"
                        @click="sendNotification('WHATSAPP')" small>
                        <v-icon left>mdi-whatsapp</v-icon>
                        Send WhatsApp
                    </v-btn>
                </v-col>
            </v-row>
             <div v-if="allocation_list.length > 0" class="mt-8 mx-2">
            <h3 class="ml-2 mb-2">Approved Allocations</h3>
                <v-data-table dense show-select item-key="id" class="elevation-1 mx-2 mt-4 custom-table" :headers="headers"
                    :items="bookList1" :search="search" :items-per-page="-1" v-model="selected" @current-items="getFiltered"
                    >
                    <template v-slot:item.action="{ item }">
                        <v-btn small color="red" dark @click="deleteAllocation(item)">
                            Delete
                        </v-btn>
                    </template>
                </v-data-table>
            </div>

            <div v-if="unapproved_list.length > 0" class="mt-8 mx-2">
                <h3 class="ml-2 mb-2">Unapproved Allocations</h3>
                <v-data-table dense class="elevation-1 custom-table" :headers="unapproved_headers"
                    :items="unapproved_list" :items-per-page="-1">
                </v-data-table>
            </div>

           <!-- Increased max-width to 1000px for enhanced breathing space -->
           <v-dialog persistent max-width="1000px" v-model="allocationDialog">
                <v-card class="d-flex flex-column" style="max-height: 95vh;">
                    <v-toolbar dense flat color="primary" dark class="flex-grow-0">
                        <v-toolbar-title>
                            Allocate Elective
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="closeDialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text class="pt-5 dialog-body-scroll">
                        <v-row dense>
                            <v-col cols="12" md="5">
                                <v-autocomplete dense outlined label="PRN" v-model="allocation.prn" :items="prn_list"
                                    @change="getLearnerDetails()" no-data-text="No PRNs found" multiple chips small-chips deletable-chips
                                    class="autocomplete-scrollable" />
                            </v-col>

                            <!-- <v-col cols="12" md="7">
                                <v-autocomplete dense outlined return-object label="Subject / Group"
                                    v-model="allocation.subject_group" :items="available_choices" item-text="name"
                                    item-value="id">
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex flex-column">
                                            <span>{{ item.name }}</span>
                                            <small class="grey--text">
                                                {{ item.type }} | {{ item.course_rule }}
                                            </small>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col> -->
                            <!-- Update this section inside your <v-dialog> -->
                            <v-col cols="12" md="7">
                                <v-autocomplete dense outlined return-object label="Subject / Group"
                                    v-model="allocation.subject_group" :items="available_choices" item-text="name"
                                    item-value="id" multiple chips small-chips deletable-chips>
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex flex-column">
                                            <span>{{ item.name }}</span>
                                            <small class="grey--text">
                                                {{ item.type }} | {{ item.course_rule }}
                                            </small>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" v-if="learners_details.length > 0">
                                <div class="mb-2 font-weight-bold grey--text text--darken-2">Selected Students Context</div>
                                
                                <div class="context-scroll-container pr-1">
                                    <v-card outlined class="pa-3 mb-3" v-for="student in learners_details" :key="student.learner_id">
                                        <div class="d-flex justify-between align-center border-bottom pb-1">
                                            <span class="font-weight-medium primary--text">{{ student.student_name }}</span>
                                            <v-spacer></v-spacer>
                                            <span class="caption grey--text font-weight-bold">PRN: {{ student.prn }}</span>
                                        </div>
                                        
                                        <div class="mt-2">
                                            <div class="caption grey--text font-weight-medium mb-1">Existing Preferences:</div>
                                            <template v-if="student.existing_choices && student.existing_choices.length > 0">
                                                <v-chip v-for="item in student.existing_choices" :key="item.id" x-small class="mr-1 mb-1"
                                                    :color="item.isapproved ? 'green' : 'orange'" dark>
                                                    {{ item.name }} ({{ item.type }})
                                                </v-chip>
                                            </template>
                                            <span v-else class="caption text--disabled italic">No choices registered</span>
                                        </div>
                                    </v-card>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="flex-grow-0 border-top">
                        <v-spacer></v-spacer>
                        <v-btn small dark color="grey" @click="closeDialog()">
                            Cancel
                        </v-btn>
                        <v-btn small dark color="primary" @click="saveElectiveAllocation()">
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="import_dialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <span class="headline">
                            Import Elective Choice
                        </span>

                        <v-spacer></v-spacer>

                        <v-btn small color="success" @click="generateCSV">
                            Download Template
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-file-input v-model="file" label="Select CSV File" prepend-icon="mdi-file" outlined rounded
                            dense show-size></v-file-input>
                    </v-card-text>

                    <v-card-actions class="justify-center">
                        <v-btn text color="error" @click="import_dialog = false">
                            Cancel
                        </v-btn>

                        <v-btn color="primary" @click="importElectiveChoice" :disabled="!file">
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="failed_dialog" max-width="900px">
                <v-card>

                    <v-card-title class="toolbar white--text">
                        Failed Import Records

                        <v-spacer></v-spacer>

                        <v-btn icon dark @click="failed_dialog = false">
                            <v-icon>
                                mdi-close
                            </v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text class="mt-4">

                        <v-data-table dense :items="failed_records" :headers="failed_headers" class="elevation-1">
                        </v-data-table>

                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios"
import * as XLSX from "xlsx"
export default {
    data() {
        return {
            search: "",
            snackbar: false,
            snackbar_msg: "",
            color: "",
            overlay: false,
            fetchLoader: false,
            ay_std_div_list: null,
            std_div_list: null,
            stream_list: null,
            sel_ay_data: null,
            sel_std_data: null,
            stream: null,
            subject: null,
            mixed_course_group_list: [],
            allocation_list: [],
            unapproved_list: [],
            prn_list: [],
            selected: [],
            filterArr: [],
            filters: {
                registration_number: [],
                name_of_candidate: [],
                category: [],
            },
            allocationDialog: false,
            allocation_subject_group_list: [],
            allocation: {
                prn: [], 
                student_name: "",
                merit_marks: "",
                subject_group: [],
            },
            learners_details: [], 
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "Choice No.", value: "preference_number" },
                { text: "PRN", value: "registration_number" },
                { text: "Candidate Name", value: "name_of_candidate" },
                { text: "Subject", value: "subject_or_group" },
                { text: "Mobile Number", value: "mobile_number" },
                { text: "Email", value: "email" },
                { text: "Gender", value: "gender" },
                { text: "Category", value: "category" },
                { text: "Merit Number", value: "merit_no" },
                { text: "Merit Marks", value: "merit_marks" },
                { text: "Academic Year", value: "ay" },
                { text: "Round", value: "round" },
                { text: "Standard", value: "standard" },
                { text: "Stream", value: "stream" },
                { text: "Action", value: "action" }
            ],
            unapproved_headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "Choice No.", value: "preference_number" },
                { text: "PRN", value: "registration_number" },
                { text: "Candidate Name", value: "name_of_candidate" },
                { text: "Subject", value: "subject_or_group" },
                { text: "Mobile Number", value: "mobile_number" },
                { text: "Email", value: "email" },
                { text: "Gender", value: "gender" },
                { text: "Category", value: "category" },
                { text: "Merit Number", value: "merit_no" },
                { text: "Merit Marks", value: "merit_marks" },
                { text: "Academic Year", value: "ay" },
                { text: "Round", value: "round" },
                { text: "Standard", value: "standard" },
                { text: "Stream", value: "stream" },
            ],
            import_dialog: false,
            file: null,
            failed_dialog: false,
            failed_records: [],
            failed_headers: [
                { text: "PRN", value: "prn" },
                { text: "Subject / Group", value: "subject_group" },
                { text: "Reason", value: "reason" }
            ],
            available_choices: [],
            existing_choices: []
        }
    },

    computed: {
        bookList1() {
            return this.allocation_list.filter((d) => {
                return Object.keys(
                    this.filters
                ).every((f) => {
                    return (
                        this.filters[f].length < 1 ||
                        this.filters[f].includes(d[f])
                    )
                })
            })
        },
    },

    methods: {
        generateCSV() {
            try {
                const headers = ["PRN", "Selection Type", "subject/group", "standard", "stream", "AY"]
                const sampleRows = [
                    ["G25260234", "Subject", "50 : BOOK KEEPING AND ACCOUNTANCY", "XI", "SCIENCE", "2025-26"],
                    ["G25260235", "Group", "COMPUTER GROUP", "XI", "SCIENCE", "2025-26"]
                ]
                const csvContent = [headers.join(","), ...sampleRows.map(row => row.join(","))].join("\n")
                const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
                const link = document.createElement("a")
                const url = URL.createObjectURL(blob)
                link.href = url
                link.setAttribute("download", "Elective_Choice_Import_Format.csv")
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            } catch (error) {
                console.log(error)
                this.showSnackbar("#b71c1c", "Failed to download CSV format")
            }
        },
        async importElectiveChoice() {
            if (!this.file) {
                this.showSnackbar("#b71c1c", "Please select file")
                return
            }
            let formData = new FormData()
            formData.append("file", this.file)
            try {
                const res = await axios.post("/Admission/importElectiveChoiceList", formData, {
                    headers: { "Content-Type": "multipart/form-data" }
                })
                if (res.data.status == "SUCCESS") {
                    this.showSnackbar("#4caf50", `${res.data.saved_count} added, ${res.data.updated_count} updated`)
                    this.import_dialog = false
                    this.file = null
                    if (res.data.skipped_records && res.data.skipped_records.length > 0) {
                        this.failed_records = res.data.skipped_records
                        this.failed_dialog = true
                    }
                    this.fetchElectiveAllocation()
                } else {
                    this.showSnackbar("#b71c1c", res.data.msg)
                }
            } catch (e) {
                console.log(e)
                this.showSnackbar("#b71c1c", "Something went wrong")
            }
        },
        sendNotification(type) {
            if (this.selected.length == 0) {
                this.showSnackbar("#b71c1c", "Please select atleast one row")
                return
            }
            const selectedIds = this.selected.map(item => item.id)
            let successMessage = type == "EMAIL" ? "Emails sent successfully" : type == "WHATSAPP" ? "WhatsApp messages sent successfully" : "SMS sent successfully"

            const data = {
                ids: selectedIds,
                type: type,
                dns: window.location.hostname
            }

            axios.post("/communicationType/sendElectiveAllocationNotification", data)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.showSnackbar("#4caf50", successMessage)
                        this.fetchElectiveAllocation()
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason)
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.showSnackbar("#b71c1c", "Something went wrong")
                })
        },
        async openAddDialog() {
             if (!this.sel_ay_data || !this.sel_std_data || !this.stream) {
                 this.showSnackbar("#b71c1c", "Please select AY, Standard and Stream first")
                 return
             }
            this.allocationDialog = true
            await this.getPrnList()
        },

        async getPrnList() {
            const data = {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data,
                stream: this.stream,
                subjectGroup: this.subject.id,
                selection_type: this.subject.selection_type
            }
            try {
                const res = await axios.post("/Admission/getPrnList", data)
                if (res.data.flag == "YES") {
                    this.prn_list = res.data.prn_list || []
                } else {
                    this.showSnackbar("#b71c1c", res.data.msg || "Failed to fetch PRN list")
                }
            } catch (error) {
                console.error(error)
                this.showSnackbar("#b71c1c", "Something went wrong while fetching PRN list")
            }
        },

        closeDialog() {
            this.resetAllocationForm()
            this.allocationDialog = false
        },
        resetAllocationForm() {
            this.allocation = {
                prn: [],
                student_name: "",
                merit_marks: "",
                subject_group: [],
            }
            this.learners_details = []
            this.available_choices = []
            this.existing_choices = []
        },

        async getLearnerDetails() {
            if (!this.allocation.prn || this.allocation.prn.length === 0) {
                this.learners_details = []
                this.available_choices = []
                return
            }

            const data = {
                prn: this.allocation.prn, 
                ay: this.sel_ay_data.ay_id,
            }

            try {
                const res = await axios.post("/Admission/getLearnerDetails", data)

                if (res.data.flag == "YES" && res.data.learners) {
                    this.learners_details = res.data.learners;

                    let combinedChoices = []
                    res.data.learners.forEach(learner => {
                        if (learner.flag == "YES" && learner.available_choices) {
                            combinedChoices.push(...learner.available_choices)
                        }
                    })
                    
                    this.available_choices = Array.from(
                        new Map(combinedChoices.map(c => [`${c.id}_${c.type}`, c])).values()
                    )
                } else {
                    this.learners_details = []
                    this.available_choices = []
                    this.showSnackbar("#b71c1c", res.data.msg || "Error processing records")
                }
            } catch (error) {
                this.learners_details = []
                this.available_choices = []
                this.showSnackbar("#b71c1c", "Something went wrong...")
            }
        },
       
        async saveElectiveAllocation() {
            if (!this.allocation.prn || this.allocation.prn.length === 0) {
                this.showSnackbar("#b71c1c", "Please select at least one PRN")
                return
            }

            if (!this.allocation.subject_group) {
                this.showSnackbar("#b71c1c", "Please select subject/group")
                return
            }

            const data = {
                prn: this.allocation.prn, 
                ay: this.sel_ay_data.ay_id,
                std: this.sel_std_data,
                stream: this.stream,
                // allocation_id: this.allocation.subject_group.id,
                // allocation_type: this.allocation.subject_group.type,
                allocations: this.allocation.subject_group.map(item => ({
                    id: item.id,
                    type: item.type,
                    name: item.name
                }))
            }

            try {
                const res = await axios.post("/Admission/saveElectiveAllocation", data)
                
                if (res.data.skipped_records && res.data.skipped_records.length > 0) {
                    // this.failed_records = res.data.skipped_records.map(record => ({
                    //     prn: record.prn,
                    //     subject_group: this.allocation.subject_group ? this.allocation.subject_group.name : 'N/A',
                    //     reason: record.reason
                    // }))
                    this.failed_records = res.data.skipped_records.map(record => ({
                        prn: record.prn,
                        subject_group: record.subject_group || 'N/A',
                        reason: record.reason
                    }))
                    this.failed_dialog = true
                }

                if (res.data.flag == "YES") {
                    this.showSnackbar("green", res.data.msg) 
                    this.closeDialog()
                    this.fetchElectiveAllocation()
                } else {
                    this.showSnackbar("#b71c1c", res.data.msg)
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong...")
            }
        },
       
        deleteAllocation(item) {
            if (!confirm("Are you sure you want to remove this allocation?")) return;
            const data = { id: item.id };
            axios.post("/admission/deleteElectiveAllocation", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", res.data.msg || "Elective Allocation Removed Successfully...");
                        this.fetchElectiveAllocation();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                });
        },
        getFiltered(e) { this.filterArr = e },
        columnValueList(val) { return this.allocation_list.map((d) => d[val]) },

        getCourseOffering() {
            this.mixed_course_group_list = []
            this.subject = null
            const formData = {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data,
                stream: this.stream
            }
            axios.post("/Examination/getSubjectGroupMixedList", formData)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.mixed_course_group_list = res.data.mixed_course_group_list
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!")
                    }
                })
                .catch(() => { this.showSnackbar("#b71c1c", "Something went wrong...") })
        },

        getStd() {
            this.std_div_list = null
            this.sel_std_data = null
            this.std_div_list = this.sel_ay_data.std_list
        },

        async fetchElectiveAllocation() {
            this.fetchLoader = true;
            const data = {
                ay: this.sel_ay_data.ay_id,
                std: this.sel_std_data,
                stream: this.stream,
                subjectGroup: this.subject.id,
                selection_type: this.subject.selection_type
            }
            try {
                const res = await axios.post("/Admission/fetchElectiveAllocation", data)
                if (res.data.flag == "YES") {
                    this.allocation_list = res.data.allocation_list || [];
                    this.unapproved_list = res.data.unapproved_list || [];
                    if (this.allocation_list.length == 0 && this.unapproved_list.length == 0) {
                        this.showSnackbar("#b71c1c", "No Data Found...")
                    }
                    this.fetchLoader = false;
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong...")
                this.fetchLoader = false;
            }
        },

        showSnackbar(clr, msg) {
            this.snackbar = true
            this.color = clr
            this.snackbar_msg = msg
        },

        onload() {
            this.overlay = true;
            axios.post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data
                    this.sel_ay_data = res.data.sel_ay_data
                    this.stream_list = res.data.stream_list
                    this.overlay = false;
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...")
                    this.overlay = false;
                })
        },
    },

    mounted() { this.onload() },
}
</script>

<style scoped>
.custom-table ::v-deep tbody tr td {
    padding-top: 14px !important;
    padding-bottom: 14px !important;
    vertical-align: middle;
}
.border-bottom {
    border-bottom: 1px solid #e0e0e0;
}
.border-top {
    border-top: 1px solid #e0e0e0;
}

.dialog-body-scroll {
    max-height: 75vh;
    overflow-y: auto;
}

.context-scroll-container {
    max-height: 380px;
    overflow-y: auto;
    overflow-x: hidden;
}

.autocomplete-scrollable ::v-deep .v-select__selections {
    max-height: 160px;
    overflow-y: auto !important;
}
</style>